import { getElementTag } from '../../lib/get-element-tag.ts'

import hydrate from './components/hydrate.js'

const tag = getElementTag(__APP_NAME__, 'innholdsvideo', __APP_VERSION__)

class AppElement extends HTMLElement {
  name = tag

  connectedCallback() {
    hydrate(this, this.preloadedState)
  }

  get preloadedState() {
    return this.dataset.preloadedState ? JSON.parse(this.dataset.preloadedState) : null
  }
}

if (!customElements.get(tag)) {
  customElements.define(tag, AppElement)
}
